import React, { useState } from 'react';
import classnames from 'classnames';
import { titleize } from 'underscore.string';
import Badge from 'components/v2/Badge';
import RefreshIcon from 'components/v2/icons/RefreshIcon';
import Tooltip from 'components/ui/Tooltip';
import usePoller from 'hooks/usePoller';
import {
  getBillingStatusBadgeColor,
} from 'helpers/status-bar';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import { evaluateBillingStatus } from 'utils/ShipmentWebAPIUtils';

export default function BillingStatus({ shipment, t }) {
  if (!isIntermodalShipmentType(shipment)) {
    return null;
  }

  const [disabled, setDisabled] = useState(false);
  const { resetTimer } = usePoller(() => setDisabled(false));

  const handleClick = async () => {
    const shipmentId = shipment?._id ?? shipment;
    if (!disabled && shipmentId) {
      await evaluateBillingStatus([shipmentId]);
      setDisabled(true);
      resetTimer();
    }
  };

  const billingStatus = shipment?.billing_status;
  if (!billingStatus) {
    return null;
  }

  const renderIcon = () => {
    const tooltip = disabled
      ? 'BILLING_STATUS_REFRESH_DISABLED'
      : 'BILLING_STATUS_REFRESH_ENABLED';
    return (
      (<Tooltip
        dataTestId="Tooltip-1dd2065b"
        id="tooltip-master-ref"
        content={t(tooltip)}
        position="top">
        <div data-testid="div-dc6979d4" className="my-auto" onClick={handleClick}>
          <RefreshIcon
            className={classnames({ disabled, 'w-4': true, 'h-4': true })}
          />
        </div>
      </Tooltip>)
    );
  };

  return (
    (<div data-testid="div-c1280eb9" className="flex">
      <Badge
        dataTestId="Badge-cd8ed2f4"
        className="mx-2"
        color={getBillingStatusBadgeColor(billingStatus)}>
        {titleize(t(billingStatus?.toUpperCase()))}
      </Badge>
      {renderIcon()}
    </div>)
  );
}
